var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { createStyles, withStyles } from '@material-ui/core/styles';
import MuiTableCell from '@material-ui/core/TableCell';
var StyledTableCell = withStyles(function () {
    return createStyles({
        head: function (props) { return (__assign({ fontWeight: 'bold', fontSize: 10, letterSpacing: '-0.21px', height: '12px', lineHeight: '12px', border: 0 }, ((props.style && props.style.head) || {}))); },
        body: function (props) { return (__assign({ fontSize: 10, borderBottom: 0, letterSpacing: '-0.21px' }, ((props.style && props.style.body) || {}))); },
    });
})(MuiTableCell);
export default function TableCell(_a) {
    var style = _a.style, align = _a.align, children = _a.children;
    return (React.createElement(StyledTableCell, { align: align, style: style }, children));
}
TableCell.defaultProps = {
    align: 'left',
};
//# sourceMappingURL=TableCell.js.map